var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeclinedFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#09101A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM7.14772 7.86076C6.95081 7.66385 6.95081 7.34459 7.14772 7.14768C7.34463 6.95077 7.66389 6.95077 7.8608 7.14768L9.99999 9.28687L12.1392 7.14769C12.3361 6.95078 12.6553 6.95078 12.8522 7.14769C13.0492 7.3446 13.0492 7.66386 12.8522 7.86077L10.7131 9.99995L12.8523 12.1392C13.0492 12.3361 13.0492 12.6554 12.8523 12.8523C12.6554 13.0492 12.3362 13.0492 12.1392 12.8523L9.99999 10.713L7.86072 12.8523C7.66381 13.0492 7.34456 13.0492 7.14765 12.8523C6.95074 12.6554 6.95074 12.3361 7.14765 12.1392L9.28691 9.99995L7.14772 7.86076Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeclinedFill);
export default __webpack_public_path__ + "static/media/icon-declined-fill.b367c7253d10692ab9a1be65e8e573d1.svg";
export { ForwardRef as ReactComponent };